import { useAppDispatch } from 'common/hooks/redux'
import { type ProcedureItem } from 'features/Procedure/state/procedure-api.type'
import {
  mergeProcedureDrawingElements,
  setSelectedEncounterUid,
  setSelectedComparisonEncounterUid,
  setSelectedFormDocId,
  setSelectedLabId,
  setSelectedPatientId,
  setSelectedProcedure,
} from 'features/Procedure/state/procedure.slice'
import type { DrawingElement } from 'features/Procedure/state/procedure.type'
import { useCallback, useMemo } from 'react'

export const useProcedureActions = () => {
  const dispatch = useAppDispatch()

  const handleSetSelectedEncounterUid = useCallback(
    (encounterUid: string | null) => {
      dispatch(setSelectedEncounterUid(encounterUid))
    },
    [dispatch],
  )

  const handleSetSelectedComparisonEncounterUid = useCallback(
    (encounterUid: string | null) => {
      dispatch(setSelectedComparisonEncounterUid(encounterUid))
    },
    [dispatch],
  )

  const handleSetSelectedPatientId = useCallback(
    (patientId: number | null) => {
      dispatch(setSelectedPatientId(patientId))
    },
    [dispatch],
  )

  const handleSetSelectedProcedure = useCallback(
    (procedure: ProcedureItem | null) => {
      dispatch(setSelectedProcedure(procedure))
    },
    [dispatch],
  )

  const handleSetSelectedLabId = useCallback(
    (labId: number | null) => {
      dispatch(setSelectedLabId(labId))
    },
    [dispatch],
  )

  const handleSetSelectedFormDocId = useCallback(
    (formDocId: number | null) => {
      dispatch(setSelectedFormDocId(formDocId))
    },
    [dispatch],
  )

  const handleMergeProcedureDrawingElements = useCallback(
    (drawings: DrawingElement[]) => {
      dispatch(mergeProcedureDrawingElements(drawings))
    },
    [dispatch],
  )

  return useMemo(
    () => ({
      handleSetSelectedEncounterUid,
      handleSetSelectedComparisonEncounterUid,
      handleSetSelectedPatientId,
      handleSetSelectedProcedure,
      handleSetSelectedLabId,
      handleSetSelectedFormDocId,
      handleMergeProcedureDrawingElements,
    }),
    [
      handleSetSelectedEncounterUid,
      handleSetSelectedComparisonEncounterUid,
      handleSetSelectedPatientId,
      handleSetSelectedProcedure,
      handleSetSelectedLabId,
      handleSetSelectedFormDocId,
      handleMergeProcedureDrawingElements,
    ],
  )
}
